module.exports = __webpack_public_path__ + "img/409f1c9.jpg";